import { SET_CONTENT_SUBMISSION_MODAL_OPEN } from './contentSubmissionTypes';

interface SetContentSubmissionModalOpenAction {
  type: typeof SET_CONTENT_SUBMISSION_MODAL_OPEN;
  payload: boolean;
}

export type ContentSubmissionActionTypes = SetContentSubmissionModalOpenAction;

export const setContentSubmissionModalOpen = (isOpen: boolean): SetContentSubmissionModalOpenAction => ({
  type: SET_CONTENT_SUBMISSION_MODAL_OPEN,
  payload: isOpen,
});
